import { createFileRoute } from '@tanstack/react-router';

import { DmOfferCheckoutPage } from 'src/apps/checkout/app/pages/DmOffer.Checkout';

export const Route = createFileRoute(
  '/_auth/_only-header/store/dm-offer/_allowed/checkout'
)({
  component: () => <DmOfferCheckoutPage />,
});
